import React from 'react'
import type { StyleProp } from '@vtex/admin-ui'
import { Text, csx } from '@vtex/admin-ui'

import type { Occurrence } from '../../shared/types'

const containerStyles: StyleProp = {
  marginBottom: '$space-6',
}

const breadcrumbStyles: StyleProp = {
  display: 'block',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  direction: 'rtl',
  textAlign: 'left',
}

export type OccurrencesBreadcrumbProps = {
  occurrences: Occurrence[]
}

export const OccurrencesBreadcrumb = ({
  occurrences,
}: OccurrencesBreadcrumbProps) => {
  if (!occurrences.length) {
    return null
  }

  const breadcrumbString = occurrences
    .map((occurrence) => occurrence.record.name)
    .join(' / ')

  return (
    <div className={csx({ ...containerStyles })}>
      <Text className={csx({ ...breadcrumbStyles })} variant="title2">
        {breadcrumbString}
      </Text>
    </div>
  )
}
